import * as angular from 'angular';
import {IController} from "angular";

export class CreateOMSOrderButtonCtrl implements IController {
  /* @ngInject */
  constructor( ) {
  }

}

angular
  .module('bringoz.admin.oms')
  .component('createOmsOrderButton', {
    template: require('./create-oms-order-button.html').default,
    controller: CreateOMSOrderButtonCtrl
  });
